import styled from 'styled-components';
import {
    PlanCtaButton,
    PlanPrice,
    PlanName,
    PlanDescription,
    IncludedBlock,
    IncludedText,
} from 'vendor/components/Webstore/PickYourPlanSection/PearlConnectPlanTile.styled';

// Card, icon and CTA styles for the Signature Collection plan tiles (Figma "Pearl Connect/Plan
// Selector"). Typography, checklist rows, badge and price styles are shared with
// PearlConnectPlanTile.styled.

const CARD_STROKE = '#bdbdbd';
const CARD_STROKE_ACTIVE = '#8dbbb8';
const CARD_FILL_ACTIVE = '#dcebe9';

export const SignatureIconContainer = styled.div`
    flex-shrink: 0;
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 60px;
    background: ${({ $background }) => $background};

    img {
        display: block;
        width: 24px;
        height: 24px;
    }
`;

export const SignatureCardBody = styled.div`
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

export const SignatureLeadIn = styled.span`
    font-family: 'Objektiv Mk2', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    color: #040404;
`;

export const SignatureTagline = styled.div`
    width: 100%;
    font-family: 'Objektiv Mk2', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    color: #040404;
`;

// The design's CTA hugs its label, unlike the full-width PlanCtaButton it is based on.
export const SignatureCtaButton = styled(PlanCtaButton)`
    width: auto;
    align-self: flex-start;
    text-transform: capitalize;

    &:disabled {
        cursor: default;
        border-color: #dcdcdc;
        background: #fff;
        color: #bdbdbd;
    }
`;

// Defined last: its desktop rules refer to the components above.
export const SignaturePlanCard = styled.div`
    position: relative;
    box-sizing: border-box;
    flex: 1 1 0;
    min-width: 0;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid ${({ $isSelected }) => ($isSelected ? CARD_STROKE_ACTIVE : CARD_STROKE)};
    background: ${({ $isSelected }) => ($isSelected ? CARD_FILL_ACTIVE : '#fff')};
    text-align: left;

    @media (max-width: 992px) {
        flex: 0 0 auto;
        width: 100%;
    }

    /* Desktop only: tighter spacing so the three cards fit on one screen next to the header. */
    @media (min-width: 993px) {
        gap: 10px;
        padding: 14px;

        ${PlanName},
        ${PlanDescription},
        ${IncludedText},
        ${SignatureLeadIn},
        ${SignatureTagline} {
            font-size: 13px;
            line-height: 20px;
        }

        ${PlanPrice} {
            font-size: 18px;
            line-height: 26px;
        }

        ${SignatureCardBody} {
            gap: 10px;
        }

        ${IncludedBlock} {
            gap: 6px;
        }
    }
`;
